import { getStore } from 'shared/stash.js';
import * as UA from './UnboundFlashMessageActions';

const lazyBindActionCreator = actionCreator => {
  return (...rest) => {
    return getStore().dispatch(actionCreator(...rest));
  };
};

const actions = {
  addFlashMessage: lazyBindActionCreator(UA.addFlashMessage),
  dismissFlashMessage: lazyBindActionCreator(UA.dismissFlashMessage),
  flashSuccess: lazyBindActionCreator(UA.flashSuccess),
  flashError: lazyBindActionCreator(UA.flashError),
  flashInfo: lazyBindActionCreator(UA.flashInfo),
  flashWarning: lazyBindActionCreator(UA.flashWarning),

  dispatchServerFlashMessages: ({ flashMessages }) => {
    if (flashMessages && flashMessages.length > 0) {
      flashMessages.forEach(flash => {
        switch (flash.type) {
          case 'success':
            actions.flashSuccess({ message: flash.message });
            break;
          case 'error':
            actions.flashError({ message: flash.message });
            break;
          default:
            actions.flashInfo({ message: flash.message });
        }
      });
    }
  },
};

export default actions;
